var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "color-container", attrs: { id: "coloriFrontali" } },
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            "multi-line": "",
            right: "",
            bottom: "",
            timeout: "10000",
            color: "warning",
          },
          model: {
            value: _vm.giacWarning,
            callback: function ($$v) {
              _vm.giacWarning = $$v
            },
            expression: "giacWarning",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                gap: "0.5em",
                "justify-content": "center",
                "align-items": "center",
              },
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.giacWarningMessage))]),
              _c(
                "v-btn",
                {
                  staticStyle: { padding: "0 !important", "min-width": "36px" },
                  attrs: { text: "", rounded: "", size: "x-small" },
                  on: {
                    click: function ($event) {
                      _vm.giacWarning = false
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "toolbar", class: { dark: _vm.darkTheme } },
        [
          _c(
            "v-layout",
            {
              staticClass: "items-center selected-bar align-center",
              staticStyle: { gap: "2em" },
            },
            [
              _vm.config.colori_search
                ? _c(
                    "v-flex",
                    { staticClass: "cerca-wrap select-layout" },
                    [
                      _c(
                        "v-text-field",
                        {
                          attrs: {
                            variant: "underlined",
                            clearable: "",
                            "append-icon": "search",
                          },
                          on: { keyup: _vm.hideMobileKeyboardOnReturn },
                          model: {
                            value: _vm.searchQuery,
                            callback: function ($$v) {
                              _vm.searchQuery = $$v
                            },
                            expression: "searchQuery",
                          },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.Cerca")) +
                                  " (" +
                                  _vm._s(_vm.filteredColors.length) +
                                  " " +
                                  _vm._s(_vm.$t("message.colori")) +
                                  ") "
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-select", {
                staticClass: "categories-select select-layout",
                attrs: {
                  "menu-props": { offsetY: true, top: false, maxHeight: "20%" },
                  "deletable-chips": "",
                  clearable: "",
                  "small-chips": "",
                  dense: "",
                  "hide-details": "",
                  items: _vm.categories,
                  label: _vm.$t("message.Categorie_lastre"),
                  multiple: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function ({ item, index }) {
                      return [
                        index < 1
                          ? _c(
                              "v-chip",
                              {
                                attrs: { small: "", close: "" },
                                on: {
                                  "click:close": function ($event) {
                                    return _vm.removeChip(item)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(item))])]
                            )
                          : _vm._e(),
                        index === 1
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "text-grey text-caption align-self-center",
                              },
                              [
                                _vm._v(
                                  " (+" +
                                    _vm._s(_vm.category.length - 1) +
                                    " others) "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.category,
                  callback: function ($$v) {
                    _vm.category = $$v
                  },
                  expression: "category",
                },
              }),
              _vm.config.colori_finiture
                ? _c(
                    "v-flex",
                    { staticClass: "finitura-wrap select-layout" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          clearable: "",
                          items: _vm.filtriColori,
                          "item-text": "nome",
                          "return-object": true,
                          label: "Categorie Colori",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.filtroColori,
                          callback: function ($$v) {
                            _vm.filtroColori = $$v
                          },
                          expression: "filtroColori",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.config.colori_finiture
                ? _c(
                    "v-flex",
                    { staticClass: "finitura-wrap select-layout" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          items: _vm.finituraOptions,
                          "item-text": "text",
                          "item-value": "id",
                          "return-object": false,
                          label: _vm.$t("message.Finitura"),
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.finitura,
                          callback: function ($$v) {
                            _vm.finitura = $$v
                          },
                          expression: "finitura",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-flex",
                {
                  staticClass: "tinta-unita-wrap select-layout",
                  staticStyle: { gap: "10px" },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.Tinta_unita")))]),
                  _c(
                    "v-btn-toggle",
                    {
                      attrs: { mandatory: "" },
                      model: {
                        value: _vm.tintaUnita,
                        callback: function ($$v) {
                          _vm.tintaUnita = $$v
                        },
                        expression: "tintaUnita",
                      },
                    },
                    [
                      _c("v-btn", { attrs: { value: true } }, [
                        _vm._v(_vm._s(_vm.$t("message.Si"))),
                      ]),
                      _c("v-btn", { attrs: { value: false } }, [_vm._v("NO")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ItemsCarousel", {
        attrs: {
          itemsType: _vm.itemsType,
          itemsCarousel: _vm.filteredColors,
          itemsWrap: _vm.config.colori_wrap,
          activeElement: _vm.coloreActive,
        },
        on: { "item-selected": _vm.coloreSelected },
      }),
      _c("samplesModelDialog", {
        attrs: {
          showSampleDialog: _vm.showSampleDialog,
          darkTheme: _vm.darkTheme,
        },
        on: {
          close: function ($event) {
            _vm.showSampleDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }